var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fetching-error-box",class:_vm.$style['wrapper']},[_c('ds-fetching-error-icon'),_c('span',{class:_vm.$style['text']},[_vm._v(_vm._s(_vm.$t('loading error')))]),_c('ds-button',{staticClass:"fetching-error-btn",on:{"click":function($event){_vm.$emit('retry')}}},[_vm._v("\n    "+_vm._s(_vm.$t('retry'))+"\n  ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215f26e0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../panel-theme/src/js/widgets/ds-fetching-error.vue
// module id = null
// module chunks = 